import { createSlice } from "@reduxjs/toolkit";
import cloneDeep from 'lodash/cloneDeep';
import {
  onSetLoaded, onSetError, onSetLoadedCreate, onSetLoadedDelete, onSetLoadedUpdate,
  onErrorCreate, onErrorUpdate, onErrorDelete, createFailed, updateFailed, deleteFailed
} from './../utils/loadedError';
import { getUserTZString, userTZNumber } from "../../services/timezone";

const deleteRecords = (initialState, data) => {
  switch (data.action) {
    case "restore":
      return initialState.deletedData.filter((item) => item !== data.record);
    case "delete":
      return [...initialState.deletedData, data.record];
    default:
      return initialState.deletedData;
  }
};

const addRecordBeforeAfter = (items, portal, action, id) => {
  let newRecord = {
    id: it.next().value,
    portal_name: portal.portalName,
    portal_id: portal.portalId,
    customer_id: null,
    wellbore_id: null,
    date_start: null,
    date_finish: null,
    count_days: "",
    loss: "",
    responsible: "",
    problem_solution: "",
    cluster_name: "",
    // ordinal_number: null,
    isNew: true,
    time_zone: portal.portalTZ,
  };

  let newData = [...items];
  
  const indexCur = newData.findIndex(item => item.id === id);
  let indexNewRecord = null;

  if (action === 'before') {
    indexNewRecord = indexCur;
  }
  if (action === 'after') {
    indexNewRecord = indexCur + 1;
  }

  if (indexNewRecord < 0) {
    newData.unshift(newRecord);
  } else {
    newData.splice(indexNewRecord, 0, newRecord);
  }

  return changeOrdinalNumber(newData);
}

const changeOrdinalNumber = (items) => {
  let newData = [...items];

  return newData.map((item, index) => {
    item.ordinal_number = index + 1;
    return item;
  });
}

function* idMaker() {
  var index = -1;
  while (true) yield index--;
}

let it = idMaker();

const initialincidentsState = {
  dataAll: [],
  portals: [],
  portalsIsSet: false,
  dataAllIsSet: false,
  isLoaded: false,
  Error: null,
};

const incidentsSlice = createSlice({
  name: "incidents",
  initialState: initialincidentsState,
  reducers: {
    onClearStore(state) {
      state.dataAll = [];
      state.portals = [];
      state.portalsIsSet = false;
      state.dataAllIsSet = false;
      state.isLoaded = false;
      state.Error = null;
    },

    createStoreByPortals(state, action) {
      let portals = action.payload;
      portals.forEach((portal) => {
        state[portal.id] = {
          data: [],
          changedData: [],
          deletedData: [],
        };
      });
      state.portals = portals;
      state.portalsIsSet = true;
    },

    onInitialIncidents(state, action) {
      state.dataAll = action.payload;
      state.dataAllIsSet = true;
      state.isLoaded = true;
      state.Error = null;
      state.isLoadedCreate = true;
      state.isLoadedDelete = true;
      state.isLoadedUpdate = true;
      state.errorCreate = null;
      state.errorDelete = null;
      state.errorUpdate = null;
    },

    deleteDataByWellbore(state, action) {
      let wellbore_id = action.payload;

      state.dataAll = state.dataAll.filter(item=>item.wellbore_id !== wellbore_id);
      state.portals.forEach((portal) => {
        state[portal.id].data = state[portal.id].data.filter(item=>item.wellbore_id !== wellbore_id);
        state[portal.id].changedData = state[portal.id].changedData.filter(item=>item.wellbore_id !== wellbore_id);
      });

    },

    onSetDataByPortals(state, action) {
      let dataAll = state.dataAll;
      state.portals.forEach((portal) => {

        state[portal.id].data = dataAll.filter(
          (item) => item.portal_id === portal.id
        ).sort((a, b) => a.ordinal_number >= b.ordinal_number ? 1 : -1);

        state[portal.id].changedData = dataAll.filter(
          (item) => item.portal_id === portal.id
        ).sort((a, b) => a.ordinal_number >= b.ordinal_number ? 1 : -1);

        state[portal.id].deletedData = [];
      });
    },

    onSetLoaded,
    onSetError,
    onSetLoadedCreate,
    onSetLoadedUpdate,
    onSetLoadedDelete,
    onErrorCreate,
    onErrorUpdate,
    onErrorDelete,
    createFailed,
    updateFailed,
    deleteFailed,

    deleteDataSuccess(state, action) {
      let id = action.payload.data;
      let portal = action.payload.portal;
      state[portal].data = state[portal].data.filter((item) => item.id !== id);
      state[portal].changedData = changeOrdinalNumber(state[portal].changedData.filter(item => item.id !== id));
      state[portal].deletedData = state[portal].deletedData.filter(item => item !== id);
    },

    updateDataSuccess(state, action) {
      let data = action.payload.data;
      let portal = action.payload.portal;
      state[portal].data = state[portal].data.map((item) => item.id === data.id ? data : item);
      state[portal].changedData = state[portal].changedData.map((item) => item.id === data.id ? data : item);
    },

    createDataSuccess(state, action) {
      let data = action.payload.data;
      let oldId = action.payload.oldId;
      let portal = action.payload.portal;
      state[portal].data = [...state[portal].data, data];
      state[portal].changedData = state[portal].changedData.map((item) => item.id === oldId ? data : item);
    },

    changeData(state, action) {
      const record = action.payload.record;
      const property = action.payload.property;
      const portal = action.payload.portal;
      state[portal].changedData = state[portal].changedData.map((item) =>
        item.id === record.id ? { ...item, [property]: record[property] } : item
      );
    },

    deleteData(state, action) {
      const Id = action.payload.record;
      const isNew = action.payload.isNew;
      const portal = action.payload.portal;
      if (!isNew) {
        state[portal].deletedData = [...deleteRecords(state[portal], action.payload)];
      } else {
        state[portal].changedData = changeOrdinalNumber(state[portal].changedData.filter((item) => item.id !==Id));
      }
    },

    createData(state, action) {
      let portalId = action.payload;
      const portal = state.portals.find(p => p.id === portalId);
      const portalTZ = portal.time_zone + userTZNumber || null;
      const portalName = portal.portal_name || '';
      let newRecord = {
        id: it.next().value,
        portal_name: portalName,
        portal_id: portalId,
        customer_id: null,
        wellbore_id: null,
        date_start: null,
        date_finish: null,
        count_days: "",
        loss: "",
        responsible: "",
        problem_solution: "",
        cluster_name: "",
        // ordinal_number: null,
        isNew: true,
        time_zone: portalTZ,
      };

      state[portalId].changedData = changeOrdinalNumber([newRecord, ...state[portalId].changedData]);
    },

    createDataBeforeAfter(state, action) {
      let portalId = action.payload.portal;
      const portal = state.portals.find(p => p.id === portalId);
      const portalTZ = portal.time_zone + userTZNumber || null;
      const portalName = portal.portal_name || '';
      let id = action.payload.id;
      let actionAdd = action.payload.action;
      state[portalId].changedData = addRecordBeforeAfter(state[portalId].changedData, { portalId, portalName, portalTZ }, actionAdd, id);
    }
  },
});

export const incidentsActions = incidentsSlice.actions;
export default incidentsSlice.reducer;
